<template>
  <section>
    <Modal
      v-model:show="active"
      class="offer get-links-modal"
      @close="close"
    >
      <template v-slot:header>
        <h5 class="modal-title mt-8">
          {{ $t('media.card.btn') }}
        </h5>
      </template>
      <div v-loading="loading">
        <UiSelect
          v-if="$store.state.profile.user.referral_program_enabled"
          v-model="sub_affiliate_id"
          :label="$t('mediaBuying.campaign.affiliate')"
          :placeholder="$t('mediaBuying.campaign.my_account')"
          :list="referrals"
          is-search
          class="mb-16 !tw-w-full"
          @change="changeSubAffiliateId"
        />
        <UiSelect
          v-model="promo_material"
          :label="$t('media.media')"
          :placeholder="$t('profile.generalInfo.notSpecified')"
          :list="promoMaterials"
          is-search
          class="mb-16 !tw-w-full"
          @change="changePromoMaterials"
        />
        <UiSelect
          v-if="active && hideSelect(offers)"
          v-model="offer"
          :label="$t('promoCodes.addPromocodes.offer')"
          :placeholder="$t('promoCodes.addPromocodes.selectOffer')"
          :list="offers"
          is-search
          class="mb-16 !tw-w-full"
          :disabled="promo_material === ''"
          @change="changeOffer"
        />
        <!-- brand -->
        <UiSelect
          v-if="active && hideSelect(brands)"
          v-model="brand"
          :label="$t('mediaTags.brand')"
          :placeholder="$t('profile.generalInfo.notSpecified')"
          :list="brands"
          :disabled="offer === ''"
          is-search
          class="mb-16"
          @change="changeBrand"
        />
        <!-- rotation -->
        <UiSelect
          v-if="hideSelect(rotations)"
          v-model="rotation"
          :label="$t('mediaTags.rotation')"
          :placeholder="$t('profile.generalInfo.notSpecified')"
          :list="rotations"
          is-search
          class="mb-16"
          :disabled="brand === ''"
          @change="changeRotation"
        />
        <!-- target -->
        <UiSelect
          v-model="activeTab"
          :label="$t('mediaTags.target')"
          :placeholder="$t('profile.generalInfo.notSpecified')"
          :list="urls"
          is-search
          class="mb-16"
          :disabled="brand === ''"
          @change="setActive"
        />
        <div class="!tw-flex">
          <!-- languages -->
          <div
            v-if="(languages || []).length > 2"
            class="select-wrapper mb-16 !tw-w-full"
          >
            <UiSelect
              v-model="language"
              :label="$t('mediaTags.languages')"
              :placeholder="$t('mediaTags.languagesAuto')"
              :list="languages"
              :disabled="activeTab === ''"
              is-search
              @change="handlerLanguage"
            />
          </div>
          <!-- size -->
          <div
            v-if="type === 'html5_banner' || type === 'simple_banner'"
            class="select-wrapper !tw-w-full mb-16"
            :class="{ 'ml-16': (languages || []).length > 2 }"
          >
            <UiSelect
              v-model="size"
              :label="$t('mediaTags.size')"
              :placeholder="$t('profile.generalInfo.notSpecified')"
              :list="sizes"
              is-search
              :disabled="activeTab === ''"
              @change="handlerSizes"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 col-12">
            <div class="generate-tag__right-col">
              <ElPopover
                ref="popover"
                v-model:visible="warningOpen"
                placement="top-end"
                trigger="click"
                width="320"
              >
                <p>{{ $t('promoCodes.addPromocodes.changeSubId') }}</p>
                <button
                  class="btn btn-outline-primary btn-md"
                  @click="saveSubids"
                >
                  {{ $t('offerRequest.btnCancel') }}
                </button>
                <button
                  class="btn btn-primary btn-md !tw-ml-1rem"
                  @click="
                    confirmChanges();
                    warningOpen = false;
                  "
                >
                  {{ $t('offerRequest.btnConfirm') }}
                </button>

                <template v-slot:reference>
                  <div />
                </template>
              </ElPopover>

              <div
                class="select-wrapper mb-10"
                :class="{ disabled: activeTab === '' }"
              >
                <UiSelect
                  v-model="traffic_source_id"
                  :label="$t('trafficSources.trafficSource')"
                  :placeholder="$t('offerRequest.noTrafficSources')"
                  :list="list"
                  is-search
                  :disabled="activeTab === ''"
                  @change="selectTrafficSource"
                />
                <RouterLink
                  v-if="!list.length"
                  :to="{ path: '../traffic-source' }"
                  class="text-green !tw-block !tw-text-right"
                >
                  {{ $t('trafficSources.addTrafficSources.title') }}
                </RouterLink>
              </div>
              <div class="pb-12">
                <div
                  class="form-group generate-tag__form-group generate-tag__form-group--underline"
                  :class="{ 'disable-input': activeTab === '' }"
                >
                  <UiInput
                    v-model="link"
                    :label="$t('offer.card.finalPageUrl')"
                    :disabled="activeTab === ''"
                    @input="inputLink"
                  />
                </div>
                <div class="tag-wrap">
                  <span
                    v-for="item in links"
                    :key="item.page_url"
                    :class="{ 'el-tag--selected': link === item.page_url, 'disabled-link': activeTab === '' }"
                    class="el-tag el-tag--primary el-tag--small"
                    @click="setLink(item.page_url)"
                  >{{ item.name }}</span>
                </div>
              </div>
              <div class="row row-wrap__subid">
                <div
                  v-for="(item, i) in form.subids"
                  :key="i"
                  :class="{ 'disable-input': activeTab === '' }"
                  class="col-6 col-6__add-subid mb-12"
                >
                  <UiInputSubid
                    v-model="item.value"
                    :label="`SubID ${i + 1}`"
                    :disabled="activeTab === ''"
                    :placeholder="$t('trafficSources.postbacks.notSpecified')"
                    :can-delete="form.subids.indexOf(item) === form.subids.length - 1 && form.subids.length > 1"
                    @delete="popSubIds"
                  />
                </div>
                <div class="col-6 !tw-flex !tw-items-end col-6__add-subid">
                  <button
                    :disabled="form.subids.length >= 5 || activeTab === ''"
                    href="#"
                    class="btn btn-block btn-outline-primary btn-sm mb-12"
                    @click.prevent="form.subids.length < 5 && addSubId()"
                  >
                    + {{ $t('promoCodes.addPromocodes.addAnotherSubid') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-12 col-12">
            <div class="!tw-w-full pt-16 mb-getlinks">
              <h6
                v-if="type === 'landing'"
                class="textarea__track-title"
              >
                {{ $t('mediaTags.redirectUrl') }}
              </h6>
              <h6
                v-if="type.indexOf('banner') > 0"
                class="textarea__track-title"
              >
                {{ $t('mediaTags.htmlCode') }}
              </h6>
              <Copytext
                v-model:text="url"
                :button="type === 'landing' ? $t('offer.card.btn') : $t('offer.card.btnCode')"
                :success="$t('offer.card.btnDone')"
                :disabled="warningOpen"
              >
                <template v-slot:btnRight>
                  <a
                    v-if="type === 'landing' && url"
                    :href="url"
                    target="_blank"
                    class="card__btn-arrow btn btn-outline-primary btn-sm mb-4 mt-4"
                  >
                    {{ $t('mediaTags.preview') }}
                    <span class="card__triangle" />
                  </a>
                  <a
                    v-if="type === 'html5_banner' && url"
                    class="card__btn-arrow btn btn-outline-primary btn-sm mb-4 mt-4"
                    @click="mediaPreview(url)"
                  >
                    {{ $t('mediaTags.preview') }}
                    <span class="card__triangle" />
                  </a>
                </template>
              </Copytext>
            </div>
          </div>
        </div>
      </div>
      <template v-slot:footer>
        <button
          class="btn btn-outline-primary btn-sm btn-close-modal"
          @click="close"
        >
          {{ $t('offer.offerRequestSuccess.close') }}
        </button>
      </template>
    </Modal>
    <MediaPreview
      ref="mediaPreview"
      @close-banner="cBanner"
      @open-banner="oBanner"
    />
  </section>
</template>

<script>
import { mapState } from 'vuex';
import { debounce } from '@/lib/lodash';
import Copytext from '@/components/Copytext';
import { Modal } from '@/components';
import randomizer from '@/helpers/randomizer';
import MediaPreview from '@/views/Dashboard/Media/MediaPreview.vue';

export default {
  components: {
    Modal,
    Copytext,
    MediaPreview,
  },
  data() {
    return {
      offersPayload: [],
      warningOpen: false,
      params_id: '',
      params_query: '',
      active: false,
      activeTab: '',
      url: '',
      random: '',
      links: [],
      form: {
        name: '',
        extid: '',
        subids: [{ value: '' }],
      },
      promo_material: '',
      link: '',
      traffic_source_id: null,
      selected: null,
      oldTSid: '',
      checkChange: false,
      sub_affiliate_id: '',
      offer: '',
      sending: false,
      loading: false,
      size: null,
      language: '',
      type: '',
      brand: '',
      brands: [],
      customSubids: [{ value: '' }],
      locale: '',
      rotation: '',
      getUrlD: debounce(this.getUrl, 800),
      site_page: null,
      paramsSubsId: {},
      promoMaterialsLocal: [],
    };
  },
  computed: {
    ...mapState({
      marketingCampaigns: (state) => state.mediaBuying.marketingCampaigns || [],
    }),

    params() {
      if (this.type === 'landing') {
        return {
          affiliate_offer_id: this.offer,
          landing_id: this.activeTab,
          traffic_source_id: this.traffic_source_id,
          media_buying_campaign_id: this.$route.params.id,
          marketing_campaign_id: this.rotation,
          site_page: this.site_page,
          language_code: this.language,
          ...this.paramsSubsId,
        };
      }
      return {
        affiliate_offer_id: this.offer,
        landing_id: this.activeTab,
        size: this.size,
        marketing_campaign_id: this.rotation,
        media_buying_campaign_id: this.$route.params.id,
        traffic_source_id: this.traffic_source_id,
        site_page: this.site_page,
        language_code: this.language,
        ...this.paramsSubsId,
      };
    },

    rotations() {
      return this.$_.cloneDeep(this.marketingCampaigns)
        .sort(
          (a, b) => {
            if (a.type) {
              return a.type.length - b.type.length;
            }
          },
        )
        .map((e) => ({
          id: e.id,
          text: e.name,
        }));
    },

    promoMaterials() {
      const items = this.$store.state.profile.user.referral_program_enabled
        ? this.promoMaterialsLocal
        : this.$store.state.media.items;

      return items
        .map((e) => ({
          ...e,
          id: e.id,
          text: e.name,
        }));
    },
    offers() {
      const visible_brands = this.promoMaterials.find((e) => e.id === this.promo_material)?.visible_brands;
      const brandsPm = (visible_brands || []).map((i) => i.site_id);

      return this.offersPayload
        .map((e) => ({
          id: e.id,
          text: e.name,
          visible_brands: e.visible_brands,
        }))
        .filter((e) => e.visible_brands.filter((i) => brandsPm.includes(i.site_id)).length);
    },
    urls() {
      return this.$store.state.mediaBuying.landings
        .map((e) => ({
          ...e,
          text: e.name,
        }));
    },

    referrals() {
      return this.$store.state.subaffiliates.all
        .map((e) => ({
          id: e.data.id,
          text: e.email,
        }))
        .concat({
          id: '',
          text: this.$t('mediaBuying.campaign.my_account'),
        });
    },

    list() {
      let data = this.$store.state.trafficSource.list.map((e) => {
        return {
          id: e.data.id,
          text: e.name,
        };
      });
      return [{ id: '', text: this.$t('offerRequest.noTrafficSources') }].concat(data);
    },
    languages() {
      const dictionary = this.$store.state.misc.languages;
      return (this.promoMaterials.find((e) => e.id === this.promo_material)?.language_codes || []).map((e) => ({
        id: e,
        text: dictionary.find((f) => f.code === e.toLowerCase()).name,
      }));
    },
    sizes() {
      return (this.promoMaterials.find((e) => e.id === this.promo_material)?.sizes || []).map((e) => ({
        id: e,
        text: e,
      }));
    },

    calcSubIdInTrafficSource() {
      const id = this.traffic_source_id;
      if (!id) return 1;

      const subidArray = Array(5).fill(null).map((el, i) => `subid${i + 1}`);

      const targetTrafficSoutce = this.$store.state.trafficSource.list
        .find((ts) => ts.data.id === id);

      let resultCount = 1;
      subidArray.forEach((el, i) => {
        if (targetTrafficSoutce[el] !== null) {
          resultCount = i + 1;
        }
      });

      return resultCount;
    },
  },
  watch: {
    brand: {
      handler(data) {
        if (data) {
          this.$api.getFinalPages(data).then((res) => {
            this.links = res.payload.site_final_page_urls;
          });
        } else {
          this.links = [];
        }
      },
    },
    'form.subids': {
      handler(subids) {
        this.parseSubids(subids);
      },
      deep: true,
    },

    traffic_source_id(value, oldValue) {
      if (this.checkChange) return;
      this.oldTSid = oldValue;

      let oldSource = this.$store.state.trafficSource.list.filter((e) => e.data.id === oldValue)[0];
      oldSource = this.$_.pick(oldSource, ['subid1', 'subid2', 'subid3', 'subid4', 'subid5']);
      const subids = {};

      if (!value) {
        for (let i = 0; i < 5; i++) {
          const key = `subid${i + 1}`;
          subids[key] = this.form.subids[i] ? this.form.subids[i].value : null;
        }
        if (!this.$_.isEmpty(oldSource) && !this.$_.isEqual(subids, oldSource)) {
          this.addSubids(subids);
          return;
        }
        if (this.customSubids.some((e) => e.value)) {
          this.form.subids = this.customSubids;
        } else {
          // if no traffic source selected clear subids
          this.form.subids = [{ value: null }];
        }
        return;
      }

      let source = this.$store.state.trafficSource.list.filter((e) => e.data.id === value)[0];
      this.form.extid = source.data.extid || '';
      source = this.$_.pick(source, ['subid1', 'subid2', 'subid3', 'subid4', 'subid5']);
      // if no traffic source selected, like from start
      if (!oldValue) {
        if (this.form.subids === 1 || !this.form.subids[0].value) {
          // if subids empty
          this.addSubids(source);
        } else {
          // take current subids
          const subids = {};
          for (let i = 0; i < 5; i++) {
            const key = `subid${i + 1}`;
            subids[key] = this.form.subids[i] ? this.form.subids[i].value : null;
          }
          // test if current subids is equal with new subids
          if (this.$_.isEqual(subids, source)) {
            this.form.subids = [{ value: null }];
            this.addSubids(source);
          } else {
            // show warning
            this.warningOpen = true;
          }
        }
        return;
      }

      // take current subids
      for (let i = 0; i < 5; i++) {
        const key = `subid${i + 1}`;
        subids[key] = this.form.subids[i] ? this.form.subids[i].value : null;
      }
      // test if current subids is equal with old subids
      if (this.$_.isEqual(subids, oldSource)) {
        this.form.subids = [{ value: null }];
        this.addSubids(source);
      } else {
        // show warning
        this.warningOpen = true;
      }
    },
    locale() {
      if (this.brands[0]) {
        this.brands[0].text = this.$t('profile.generalInfo.notSpecified');
      }
    },
  },
  updated() {
    this.locale = this.$locale.value;
  },
  methods: {
    hideSelect(optoins = []) {
      return optoins.length > 1;
    },

    handlerLanguage() {
      this.getUrl();
    },

    handlerSizes() {
      this.getUrl();
    },

    parseSubids(subids) {
      if (!subids.subid1 && this.activeTab !== '') {
        const objSubs = {};
        for (let i = 0; i < subids.length; i++) {
          const key = `subid${i + 1}`;
          objSubs[key] = subids[i] ? subids[i].value : null;
        }

        this.paramsSubsId = objSubs;
        this.setActive('debounce');
      }
    },

    inputLink() {
      this.site_page = this.link;
      this.getUrlD();
    },

    setLink(url) {
      this.link = url;
      this.site_page = url;
      this.getUrl();
    },

    async changeRotation() {
      if (this.rotation === '') {
        this.resetTargetData();
        this.activeTab = '';
        this.url = '';
        return;
      }
      if (this.activeTab) {
        await this.getUrl();
      }
    },

    async changePromoMaterials() {
      this.reset();

      if (this.promo_material !== '') {
        this.loading = true;
        const id = this.sub_affiliate_id !== '' ? { sub_affiliate_id: this.sub_affiliate_id } : {};
        const offers = this.$store.dispatch('getAffiliateOffers', id).then((res) => Promise.all(res.payload.map((offer) => this.$api.getAffiliateOffer(offer.id).then((res) => {
          const { visible_brands } = res.payload;

          return {
            ...offer,
            visible_brands,
            text: offer.name,
          };
        }))));
        const traffic = this.$store.dispatch('getTrafficSources', id);
        this.$store.dispatch('getMarketingCampaigns', id);

        await Promise.all([offers, traffic]).then(([offers]) => {
          this.offersPayload = offers;
          this.loading = false;
        });

        if (this.offers.length === 1) {
          this.offer = this.offers[0].id;
          this.changeOffer();
        }

        this.type = this.promoMaterials.find((e) => e.id === this.promo_material).type;

        if (this.type === 'html5_banner' || this.type === 'simple_banner') {
          this.size = this.sizes[0]?.id || null;
        }
      }
    },
    async changeSubAffiliateId() {
      this.resetAffiliateData();
      this.promo_material = '';
      this.offer = '';
      this.brand = '';
      this.rotation = '';
      this.loading = true;
      const id = this.sub_affiliate_id !== '' ? { sub_affiliate_id: this.sub_affiliate_id } : {};
      await this.loadPromoMaterials(id);
      const offers = this.$store.dispatch('getAffiliateOffers', id).then((res) => Promise.all(res.payload.map((offer) => this.$api.getAffiliateOffer(offer.id).then((res) => {
        const { visible_brands } = res.payload;

        return {
          ...offer,
          visible_brands,
          text: offer.name,
        };
      }))));
      const traffic = this.$store.dispatch('getTrafficSources', id);

      this.$store.dispatch('getMarketingCampaigns', id);
      await Promise.all([offers, traffic]).then(([offers]) => {
        this.offersPayload = offers;
        this.loading = false;
      });
      if (this.offers.length === 1) {
        this.offer = this.offers[0].id;
        this.changeOffer();
      }
    },

    changeOffer() {
      this.resetAffiliateData();
      this.brand = '';

      if (this.offer !== '') {
        this.loading = true;

        this.$store.dispatch('getMediaContent', this.promo_material).then(() => {
          const brandsPm = this.$store.state.media.mediacontent.visible_brands.map((i) => i.site_id);

          this.$api.getAffiliateOffer(this.offer).then((res) => {
            const { visible_brands } = res.payload;
            const brands = visible_brands
              .filter((e) => brandsPm.includes(e.site_id))
              .map((e) => ({
                id: e.site_id,
                text: e.site_name,
              }));

            this.brands = brands;

            if (brands.length === 1) {
              this.brand = brands[0].id;
              this.changeBrand();
            }

            this.loading = false;
          });
        });
      }
    },

    async changeBrand() {
      this.resetAffiliateData();
      if (this.brand === '') {
        return;
      }

      await this.$store.dispatch('getLandings', { site_id: this.brand });
      this.rotation = this.rotations[0].id;
      if (this.urls.length === 1) {
        this.activeTab = this.urls[0].id;
        this.setActive();
      }
    },

    async setActive(action) {
      if (this.activeTab === '') {
        this.resetTargetData();
        this.url = '';
        return;
      }
      if (action === 'debounce') {
        await this.getUrlD();
        return;
      }
      await this.getUrl();
    },

    selectTrafficSource() {
      this.checkChange = false;
      this.getUrlD();
    },

    async getUrl() {
      if (this.type === 'landing') {
        const {
          payload: { url },
        } = await this.$api.getMarketingMaterialLandingUrl(this.promo_material, this.params);
        this.url = url;
        return;
      }

      const {
        payload: { script },
      } = await this.$api.getMarketingMaterialBannerScript(this.promo_material, this.params);
      this.url = script;
    },

    open() {
      this.reset();
      this.random = randomizer();
      this.active = true;
      this.loading = true;
      const id = this.sub_affiliate_id !== '' ? { sub_affiliate_id: this.sub_affiliate_id } : {};
      const items = this.loadPromoMaterials(id);
      const offers = this.$store.dispatch('getAffiliateOffers', id).then((res) => Promise.all(res.payload.map((offer) => this.$api.getAffiliateOffer(offer.id).then((res) => {
        const { visible_brands } = res.payload;

        return {
          ...offer,
          visible_brands,
          text: offer.name,
        };
      }))));
      const traffic = this.$store.dispatch('getTrafficSources', id);
      this.$store.dispatch('getLanguagesLazy');

      this.$store.dispatch('getMarketingCampaigns', id);

      Promise.all([items, offers, traffic]).then(([_, offers]) => {
        this.offersPayload = offers;
        this.loading = false;
      });
    },

    close() {
      this.active = false;
      this.promo_material = '';
      this.loading = false;
      this.reset();
    },

    reset() {
      // this.sub_affiliate_id = '';
      this.offer = '';
      this.brand = '';
      this.rotation = '';
      this.activeTab = '';
      this.url = '';
      this.type = '';
      this.size = '';
      this.language = '';
      this.traffic_source_id = null;
      this.form.subids = [{ value: null }];
      this.customSubids = [{ value: null }];
      this.paramsSubsId = {};
      this.form.extid = '';
      this.link = '';
      this.links = [];
      this.site_page = '';
      this.checkChange = false;
      this.warningOpen = false;
    },
    async loadPromoMaterials(payload = {}) {
      if (this.$store.state.profile.user.referral_program_enabled) {
        const { payload: items = [] } = await this.$api.getMarketingMaterials(payload);
        this.promoMaterialsLocal = this.$_.cloneDeep(items);
      } else {
        await this.$store.dispatch('getItems', payload);
      }
    },

    resetAffiliateData() {
      this.activeTab = '';
      this.url = '';
      this.language = '';
      this.traffic_source_id = null;
      this.form.subids = [{ value: null }];
      this.customSubids = [{ value: null }];
      this.paramsSubsId = {};
      this.form.extid = '';
      this.link = '';
      this.site_page = '';
      this.rotation = '';
      this.checkChange = false;
      this.warningOpen = false;

      if (this.type === 'html5_banner' || this.type === 'simple_banner') {
        this.size = this.sizes[0]?.id || null;
      }
    },

    resetTargetData() {
      this.language = '';
      this.traffic_source_id = null;
      this.form.subids = [{ value: null }];
      this.customSubids = [{ value: null }];
      this.paramsSubsId = {};
      this.form.extid = '';
      this.link = '';
      this.checkChange = false;
      this.warningOpen = false;

      if (this.type === 'html5_banner' || this.type === 'simple_banner') {
        this.size = this.sizes[0]?.id || null;
      }
    },

    saveSubids() {
      if (this.form.subids.length < this.calcSubIdInTrafficSource) {
        const remainder = this.calcSubIdInTrafficSource - this.form.subids.length;

        this.customSubids = [
          ...this.$_.cloneDeep(this.form.subids),
          ...Array(remainder).fill({ value: '' }),
        ].map((el) => (!el.value ? { value: '' } : el));
        this.form.subids = this.customSubids;
      } else {
        this.customSubids = this.$_.cloneDeep(this.form.subids);
      }

      this.checkChange = true;
      this.warningOpen = false;
    },
    popSubIds() {
      this.form.subids.pop();
    },
    addSubId() {
      this.form.subids.push({
        value: '',
      });
    },

    addSubids(source) {
      if (!source) {
        this.form.subids = [{ value: null }];
        return;
      }

      this.form.subids = [];
      // Push subids

      Object.keys(source).map((k) => {
        if (k.startsWith('subid')) {
          if (source[k]) {
            this.form.subids.push({
              value: source[k],
            });
          } else {
            this.form.subids.push({
              value: null,
            });
          }
        }
      });

      // reduce subids
      for (let i = this.form.subids.length - 1; i >= 1; i--) {
        if (!this.form.subids[i].value) {
          this.form.subids.pop();
        } else {
          break;
        }
      }
    },
    confirmChanges() {
      this.form.subids = [{ value: null }];
      this.customSubids = [{ value: null }];
      const source = this.$store.state.trafficSource.list.filter((e) => e.data.id === this.traffic_source_id)[0];
      this.addSubids(source);
    },
    mediaPreview(item) {
      this.$refs.mediaPreview.open(item);
    },
    cBanner() {
      this.hiddenModal = false;
    },
    oBanner(v) {
      this.hiddenModal = v;
    },
  },
};
</script>

<style lang="scss">
// vue3-migration -- '@/assets/theme/common-page-styles.scss'
// @import 'src/assets/theme/default/offers/offer';
</style>
